/**
 * Datums herkennen in vrije tekst — voor de draaidag-planner (wiki-feedback,
 * 9 sep): "de klant kan vrijdag 25 september, 9 okt of 5 november" plakken en
 * de opties eruit laten halen. Geen AI nodig: Nederlandse maandnamen, "25-9",
 * "25/09/2026", "25 sep". Zonder jaar: het eerstvolgende jaar waarin de datum
 * nog voor ons ligt (vandaag telt mee).
 */
const MAANDEN = {
  jan: 0, januari: 0, feb: 1, februari: 1, mrt: 2, maart: 2, apr: 3, april: 3, mei: 4,
  jun: 5, juni: 5, jul: 6, juli: 6, aug: 7, augustus: 7, sep: 8, sept: 8, september: 8,
  okt: 9, oktober: 9, nov: 10, november: 10, dec: 11, december: 11,
};
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

function maak(dag, maand, jaar, vandaag) {
  if (maand < 0 || maand > 11 || dag < 1 || dag > 31) return null;
  let j = jaar;
  if (j == null) {
    j = vandaag.getFullYear();
    const kandidaat = new Date(j, maand, dag);
    if (kandidaat < new Date(vandaag.getFullYear(), vandaag.getMonth(), vandaag.getDate())) j += 1;
  } else if (j < 100) j += 2000;
  const d = new Date(j, maand, dag);
  if (d.getMonth() !== maand || d.getDate() !== dag) return null; // 31 februari
  return iso(d);
}

export function datumsUitTekst(tekst, vandaag = new Date()) {
  const t = String(tekst || '').toLowerCase();
  const gevonden = new Set();
  // 25 september 2026 / 25 sep / 25 sept.
  const reMaand = /(?<![\d-/.])(\d{1,2})\s*(?:-|\s)\s*([a-z]{3,9})\.?(?:\s+(\d{2,4}))?\b/g;
  let m;
  while ((m = reMaand.exec(t))) {
    const maand = MAANDEN[m[2]];
    if (maand === undefined) continue;
    const d = maak(Number(m[1]), maand, m[3] ? Number(m[3]) : null, vandaag);
    if (d) gevonden.add(d);
  }
  // 25-9, 25/09, 25-09-2026, 2026-09-25
  const reNum = /(?<![\d-/.])(\d{1,2})[-/.](\d{1,2})(?:[-/.](\d{2,4}))?(?![\d-/.])/g;
  while ((m = reNum.exec(t))) {
    const d = maak(Number(m[1]), Number(m[2]) - 1, m[3] ? Number(m[3]) : null, vandaag);
    if (d) gevonden.add(d);
  }
  const reIso = /\b(\d{4})-(\d{2})-(\d{2})\b/g;
  while ((m = reIso.exec(t))) {
    const d = maak(Number(m[3]), Number(m[2]) - 1, Number(m[1]), vandaag);
    if (d) gevonden.add(d);
  }
  return [...gevonden].sort();
}
